// NPM Modules
import { writable } from 'svelte/store';
import collect from 'collect.js';
// Constants
import config from '@/config.js';
// Stores
import { mergeModelDataInCollectionStore } from '@/Common/Collections.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	let _store;

	const { subscribe, set, update } = writable(collect());

	subscribe((current) => (_store = current));

	// noinspection DuplicatedCode
	const methods = {
		/**
		 * ----------------- MODEL/API METHODS -----------------
		 */

		updatePriceRoll(selectionId, value, betType) {
			if (!config.RACING_ENABLED) return;

			return _store.firstWhere('id', selectionId).updatePriceRoll(value, betType);
		},

		updateDeductions(selectionId, data) {
			if (!config.RACING_ENABLED) return;

			return _store.firstWhere('id', selectionId).updateDeductions(data);
		},

		/**
		 * ----------------- STORE METHODS -----------------
		 */

		applySelectionUpdates(data) {
			if (_store.firstWhere('id', data.id.toString())) {
				mergeModelDataInCollectionStore(data, this);
			}
		},

		applyBatchSelectionUpdates(data) {
			if (!data) return;

			let selections = collect(data);
			update((items) => {
				return items.each((item) => {
					let selection = selections.firstWhere('id', parseInt(item.id));
					if (selection) {
						delete selection.id;
						item = Object.assign(item, selection);
					}
					return item;
				});
			});
		}
		// priceRollUpdated(selectionId) {
		//     let selection = _store.firstWhere('id', selectionId);
		//     if (selection) {
		//         const race = $RaceStore.firstWhere('id', selection.race_id);
		//         if (race) {
		//             RaceStore.getRaceWithDetails(race.id, race.meeting_id, false);
		//         }
		//     }
		// }
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
